import React, { Component } from 'react';
import qs from 'qs';

class ShopriteSAML extends Component {
  componentDidMount() {
    const {
      setLoading,
      createNewUserOrSignIn,
      getSSOData,
      history
    } = this.props;

    let sessId = qs.parse(this.props.location.search, { strictNullHandling: true, ignoreQueryPrefix: true  }).sessId;
    console.log('SESSION ID = ',sessId);

    setLoading(true);

    const returnUrl = encodeURIComponent(window.location.href);
    console.log('RETURN URL = ',returnUrl);

    return Promise.resolve()
      .then(() => getSSOData(sessId, returnUrl))
      .then(res => {
        console.log('RES = ',res);

        const ssoUrl = res.SSOUrl;
        console.log('SSO URL = ',ssoUrl);

        if (ssoUrl) {
            const decodedUrl = decodeURIComponent(ssoUrl)
            console.log('DECODED URL = ', decodedUrl);
          window.location = decodedUrl;
        } else {
          // {"Email":"anna@mynfo.com","FSN":"48501248386","FirstName":"Anna","LastName":"Tester","AccountId":"b42100ba-60f6-45ae-9439-cabbfc8b6b79","StoreId":"DA87780","ReturnUrl":"http://localhost:3000/saml","sessId":"bb5af712-4f38-4443-9edf-829cc3726a35"}
          const userInfo = res.UserInfo;
          console.log('USER INFO = ',userInfo);
          if (userInfo) {
            const loyaltyNum = userInfo.FSN;
            return createNewUserOrSignIn(loyaltyNum)
              .then(() => setTimeout((isNewUser) => {
                  console.log('new User ' + isNewUser)
                console.debug(`User created/signed in with loyalty number ${loyaltyNum}`);
                console.log("SAML: User Already seen Tutorial = " + window.localStorage.getItem("adjoy_seenTutorial"))
              if (isNewUser !== true) history.push('/app/campaigns');
              else history.push('/app/tutorial');
            }, 3500));
          } else {
            throw new Error('SAML: No SSO redirect Url provided and no UserInfo returned.');
          }
        }
      })
      .catch((err) => {
        console.log('SAML: Failed to redirect.');
        console.log(err);
        history.push('/');
      });
  }

  render() {
    return <div></div>;
  }
}

export default ShopriteSAML;



// WEBPACK FOOTER //
// ./src/pages/ShopriteSAML/ShopriteSAML.js